import { Component, OnInit ,OnDestroy,HostListener} from '@angular/core';
import { VgAPI, VgControlsHidden } from 'videogular2/core';
import { Observable, Subscription, combineLatest, Subject, from } from "rxjs";
import { FsDocument, FsDocumentElement, CustomWindow } from '../../../../interfaces/fullscreen.type';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Router, NavigationEnd, ActivatedRoute, ActivationEnd, RouterEvent, NavigationStart, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate
} from "@angular/router";
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { AppComponent } from 'src/app/app.component';
import { UnlServiceService } from 'src/app/services/unl-service.service';
@Component({
  selector: 'app-video-m',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
})
export class MVideoComponent implements OnInit{
  location: Location;
  adtagUrl: string;
  twindow = window as any;
  api;
subscriptions: Subscription[] = [];
  videooBject: object;
  videosrc : string;
  videotitle
  vidCatname
  videolink
  overLayT: boolean = false;
  overLayPause: boolean = false;
  overLayPlay: boolean = false;
  isPortrait = true;
  conPP: boolean;
  nodeId: any;
  autoplayboolean: boolean=true;
  ismuted: boolean=false;
 
  _iOSDevice:boolean=false;
  datadomain:string = "";
  constructor(private controlsHidden: VgControlsHidden,private app:AppComponent,
    private unlServiceService: UnlServiceService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private ngNavigatorShareService: NgNavigatorShareService,
    location: Location ) { 
      this.datadomain=this.unlServiceService.basepath;
      // this._iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
      this.location = location;
      router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        this.videosrc=null;
        const routeParams = this.activeRoute.snapshot.params;
        this.nodeId = routeParams.nodeId;
        this.ngNavigatorShareService = ngNavigatorShareService;
      }
    });
     }
     adsInt(){
     }
  ngOnInit() {
  this.videoLoader();
  
  }

adTagchange(){
  var utc=Math.round(new Date().getTime()/1000);
//this.adtagUrl='https://control-test-ec.adaptv.advertising.com/a/h/XUUFc52Hk6EG5kr_a193yZgOQ3X4tLLdnTWkWvY8K4I=?cb='+utc+'&pageUrl=http%3A%2F%2Ftest.com&ctx.pubid=NIGHTLIFE&eov=eov'
//this.adtagUrl = '//nightlife.net/viddles/mobilev.xml?cb='+utc+'&pageUrl=http%3A%2F%2Ftest.com&ctx.pubid=NIGHTLIFE&eov=eov'
}

  videoLoader(){
    /*console.log("this.api");
    console.log(this.api);*/
    this.adTagchange()
  // this.app.setvideo(false);
  this.videooBject=  this.unlServiceService.sendvpd();
  if(this.videooBject !== undefined){
    this.videosrc=this.videooBject['crr'];
    this.videotitle=this.videooBject['title'];
    this.vidCatname=this.videooBject['vidCatname'];
	this.videolink = this.videooBject['vidpath'];
  }else{
    this.http.get(
      this.unlServiceService.nodeurl +
      this.nodeId +
      this.unlServiceService.desc_Page
    ).subscribe((res)=>{
      this.videotitle = res['title']
      debugger
      this.videosrc = this.unlServiceService.basepath + res['converted_videos'].sd_mp4;
	  this.videolink = this.unlServiceService.basepath + res['path'].replace(/^\//g, '');
    });
    this.videosrc = this.unlServiceService.desc_Videos + this.nodeId;
    if(this.api.play()){
      this.overLayPlay=false;
      this.overLayPause=true;
    }else{      
      this.overLayPlay=false;
      this.overLayPause=true;
    }
  }
  this.twindow.my = {};
    this.twindow.my.unlvideo = this.twindow.my.unlvideo || {};
    this.twindow.my.unlvideo.toggleScrn = this.setFullScreen.bind(this);
  }
  // onPlayerReady(api: VgAPI) {
  //   window.scrollTo(0,1);
  //   this.api = api;
  //   var vid = document.getElementById("vgp");
  //   // this.api.fsAPI.toggleFullscreen(vid);
  //   this.api.getDefaultMedia().subscriptions.ended.subscribe(
  //     () => {
  //       // Set the video to the beginning
  //       this.api.getDefaultMedia().currentTime = 0;
  //     }
  //   );
   

  //   this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
     
  //   })

  //   this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
     
  //     // setTimeout(()=>{ this.overLayT=false}, 4090)
  //   })
  //   this.api.getDefaultMedia().subscriptions.progress.subscribe(() => {
     
  //   })
  //   screen.orientation.onchange = function () {
  //     /* logs 'portrait' or 'landscape' */
  //     console.log(screen.orientation.type.match(/\w+/)[0]);
  //     var t = screen.orientation.type.match(/\w+/)[0];
  //     var elem = document.getElementById("vgp");
  //     function tFullscreen() {
  //       this.toggleFullScreen()
  //     }
  //     try {
  //       var my: any;
  //       if (t == "landscape") {
  //         try {
  //           window["my"].unlvideo.toggleScrn(true);
  //         } catch (e) {

  //         }
  //       } else if (t == "portrait") {
  //         window["my"].unlvideo.toggleScrn(false);
  //       }
  //     } catch (e) {

  //     }
  //   };



  // }
  onPlayerReady(api: VgAPI) {
    this.api = api;
    console.log(this.api);
    var vid = document.getElementById("vgphome");
    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
      () => {
        // Set the video to the beginning
        // alert("metadata loaded");
        var mutebutton=document.getElementById("mutevideo");
        this.ismuted=false;
       // mutebutton.click();
        var html='<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        mutebutton.innerHTML=html;
      }
    );
    // this.api.fsAPI.toggleFullscreen(vid);
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );
    
    /*this.api.getDefaultMedia().subscriptions.startAds.subscribe(() => {
     alert("test")
    });*/
    this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
    })

    this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      // setTimeout(()=>{ this.overLayT=false}, 4090)
    })
    this.api.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
    })
    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' */
      console.log(screen.orientation.type.match(/\w+/)[0]);
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementById("vgphome");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };
  }
  conH() {
    this.conPP = true;
    this.overLayPlay=false;
    this.overLayPause=true;
    setTimeout(() => { if(this.overLayT)this.conPP = false; }, 4000)
  }
  nativeShare() {
    this.ngNavigatorShareService.share({
      title: 'Nightlife.net',
      text: this.videotitle,
      url: this.videolink
    }).then( (response) => {
    })
    .catch( (error) => {
      console.log(error);
    });
  }
  @HostListener('window:resize', ['$event'])
  applyOrientation() {
    if (window.innerHeight < window.innerWidth) {
      var vid = document.getElementById("vgphome");

      this.isPortrait = false;
    } else if (window.innerHeight > window.innerWidth) {
      this.isPortrait = true;
    }
  }
  setFullScreen(full: boolean): void {
    if(full){
      if(!this.isFullScreen()){
        this.toggleFullScreen();
      }
    }else{
      if(this.isFullScreen()){
        this.toggleFullScreen();
      }
    }
    /*if (full !== this.isFullScreen())
      this.toggleFullScreen();*/
  }
  pauseVG() {
    this.conPP=true;
    this.overLayPause=false;
    this.overLayPlay=true;
    this.api.pause();
  }
  playVG() {
    this.overLayT=true;
    this.conH();
    this.api.play();
  }
  toggleFullScreen(): void {
    const fsDoc = <FsDocument>document;

    if (!this.isFullScreen()) {
      const fsDocElem = <FsDocumentElement>document.getElementById("vgphome");

      if (fsDocElem.requestFullscreen)
        fsDocElem.requestFullscreen();
      else if (fsDocElem.msRequestFullscreen)
        fsDocElem.msRequestFullscreen();
      else if (fsDocElem.mozRequestFullScreen)
        fsDocElem.mozRequestFullScreen();
      else if (fsDocElem.webkitRequestFullscreen)
        fsDocElem.webkitRequestFullscreen();
    } else {
      if (fsDoc.exitFullscreen)
        fsDoc.exitFullscreen();
      else if (fsDoc.msExitFullscreen)
        fsDoc.msExitFullscreen();
      else if (fsDoc.mozCancelFullScreen)
        fsDoc.mozCancelFullScreen();
      else if (fsDoc.webkitExitFullscreen)
        fsDoc.webkitExitFullscreen();
    }
  }
  isFullScreen(): boolean {
    const fsDoc = <FsDocument>document;
    console.log(fsDoc);

    return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
  }


  // MuteAudio(event: Event) {
  //   try {
  //     const target = event.target as HTMLElement;
  //     console.log("Mute video element");
      
  //     const video = document.getElementById("popupvideoautoplay") as HTMLVideoElement;
  //     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  //     if (!video) {
  //       throw new Error("Video element not found");
  //     }
  
  //     if (!isIOS) {
  //       // For non-iOS devices
  //       if (!video.muted) {
  //         video.muted = true;
  //         target.innerHTML = `<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>`;
  //       } else {
  //         video.muted = false;
  //         target.innerHTML = `<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>`;
  //       }
  //     } else {
  //       // For iOS devices
  //       if (video.volume === 0) {
  //         video.volume = 1;
  //         target.innerHTML = `<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>`;
  //       } else {
  //         video.volume = 0;
  //         target.innerHTML = `<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>`;
  //       }
  //     }
  //   } catch (e) {
  //     console.error(e);
  //     alert(e.message);
  //   }
  // }

  
  MuteAudio(event){
    try{
      var target = event.target || event.srcElement || event.currentTarget;
      console.log("Mutevideoelement");  
      var element=target.children[0];
      var vid = <HTMLVideoElement>document.getElementById("popupvideoautoplay");
      if(!this.ismuted)
      {
        var html='<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>';
        vid.volume=0;
        vid.muted = true;
        this.ismuted=true;
         target.innerHTML=html;
       
      }else{
        vid.volume=1;
        vid.muted = false;
        this.ismuted=false;
        var html='<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        target.innerHTML=html;
      
      }
    }catch(e){
      alert(e.Message);
    }
  }

  
  setAutoplay(isMuted: boolean) {
    var vid = <HTMLVideoElement>document.getElementById("popupvideoautoplay");
    if (isMuted) {
      vid.muted = false;
    } else {
      vid.muted = true;
    }
  }
  closePage(){
    this.location.back()
  }
}